<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-27 20:16:32
 * @LastEditTime: 2020-11-24 18:05:31
--> 

<template>
  <section class="physical-banner-container">
    <md-swiper
      ref="bannerSlide"
      :autoplay="8000"
      :is-prevent="false"
      :useNative-driver="false"
      class="banner-wrapper">
      <md-swiper-item :key="item.img_url" v-for="item in bannerList">
        <a class="img-box" href="javascript:;" @click="handleToDetail(item.click_url)">
          <img :src="item.img_url" alt="">
        </a>
      </md-swiper-item>
    </md-swiper>
  </section>
</template>

<script>
import { getBanner } from '@/api/distribution'

export default {
  data() {
    return {
      bannerList: []
    }
  },
  methods: {
    //获取banner list
    loadData() {
      getBanner({type: 13}).then((res) => {
        if(res.success) {
          this.bannerList = res.data && res.data.length ? res.data.splice(0, 8) : [];
        }
      });
    },
    //去详情
    handleToDetail(url) {
      if(url.includes('physicalProductDetail')) {
        window.location.href = url
      }
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="scss">
.physical-banner-container{
  margin: 0 auto;
  width: 686px;
  height: 270px;
  .banner-wrapper {
    height: 228px;
    .md-swiper-box {
      border-radius: 12px;
    }
    .md-swiper-indicators {
      bottom: -20px !important;
      .md-swiper-indicator {
        width: 48px;
        height: 8px;
        background: #E1E1E6;
      }
      .md-swiper-indicator-active {
        background: #f73
      }
    }
  }
  .img-box{
    display: block;
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
}
</style>